import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


export interface CertificateOverviewDialogData {
  certificateId: string;
}

@Component({
  selector: 'app-certificate-overview-dialog',
  templateUrl: './certificate-overview-dialog.component.html',
  styleUrls: ['./certificate-overview-dialog.component.scss']
})
export class CertificateOverviewDialogComponent implements OnInit {
  iddTrainingCertificateId: string;

  constructor(
    public dialogRef: MatDialogRef<CertificateOverviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CertificateOverviewDialogData,
  ) {
    this.iddTrainingCertificateId = data.certificateId;
  }

  ngOnInit(): void {
  }
}
